import React, { useState, useEffect } from "react";
import { Col, Row, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { ApplicationFormAction } from "./../../redux/actions";
import { InputCheckForQualification } from "../forms/inputCheckForQualification";

const QualificationModal = (props) => {
  const [state, updateState] = useState({
    certificates: props.certificates,
  });
  const { index } = props;

  const getInput = (headTitle, title) => {
    let { certificates } = state;
    certificates[index][headTitle].push(title);
    updateState({
      ...state,
      certificates,
    });
  };

  useEffect(() => {
    const { TutorInfoObj } = props;
    //console.log(TutorInfoObj);
    /*let certificates = TutorInfoObj?.step2?.certificates
      ? TutorInfoObj?.step2?.certificates
      : props.certificates;*/

    updateState((state) => ({ ...state, certificates }));
  }, [props.TutorInfoObj]);
  const remove = (headTitle, title) => {
    let { certificates } = state;
    certificates[index][headTitle] = certificates[index][headTitle].filter(
      (degree) => degree !== title
    );
    updateState({
      ...state,
      certificates,
    });
  };
  const SaveAndCancel = () => {
    let { certificates } = state;
    if (
      certificates[index].teachingAndEducation.length < 1 &&
      certificates[index].doctoralDegree.length < 1 &&
      certificates.length > 0
    ) {
      certificates.splice(index, 1);
    }

    let TutorInfoObj = props?.TutorInfoObj ? props?.TutorInfoObj : {};
    let previouslyTutored = TutorInfoObj?.step2?.previouslyTutored;
    let providedAddistionalCerts =
      TutorInfoObj?.step2?.providedAddistionalCerts;
    let teachingCerts = TutorInfoObj?.step2?.teachingCerts;
    let lengthOfTeachingPractice =
      TutorInfoObj?.step2?.lengthOfTeachingPractice;
    let informedStudent = TutorInfoObj?.step2?.informedStudent;
    let socialUrls = TutorInfoObj?.step2?.socialUrls;

    let step2 = {
      certificates,
      previouslyTutored,
      teachingCerts,
      lengthOfTeachingPractice,
      informedStudent,
      socialUrls,
      providedAddistionalCerts,
      supportingDocs: [],
    };
    props.AddTutorInfo({ ...TutorInfoObj, step2 });
    props.onclose();
    //props.history.push("/tutor-application-form#step2");
  };

  const { certificates } = state;
  const { qualificationModal, onclose } = props;
  return (
    <Modal
      size="lg"
      centered
      className="Modal"
      show={qualificationModal}
      onHide={onclose}
    >
      <Row className="Qualification-Col flex-center-center">
        <Col lg={12} md={12} sm={12} xs={12} className="modal-content">
          <Row className="header">
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="modal-title flex-center-center"
            >
              <p className="header_options">
                Select your earned certificate and qualification
              </p>
            </Col>
          </Row>
          <div style={{ borderBottom: "1px solid #00000033" }} />
          <Row className="Qualification-body">
            <Col lg={12} md={12} sm={12} xs={12}>
              <p className="title">Teaching and education certificate</p>
            </Col>
            <Col lg={5} md={5} sm={12} xs={12}>
              <InputCheckForQualification
                headTitle={"teachingAndEducation"}
                otherHeadTitles={["doctoralDegree"]}
                getInput={getInput}
                remove={remove}
                obj={certificates[index]}
                title={"Primary"}
                id={1}
              />
            </Col>
            <Col lg={7} md={7} sm={12} xs={12}>
              <InputCheckForQualification
                headTitle={"teachingAndEducation"}
                otherHeadTitles={["doctoralDegree"]}
                getInput={getInput}
                remove={remove}
                obj={certificates[index]}
                title={"Graduate Teacher traning Program"}
                id={2}
              />
            </Col>
            <Col lg={5} md={5} sm={12} xs={12}>
              <InputCheckForQualification
                headTitle={"teachingAndEducation"}
                otherHeadTitles={["doctoralDegree"]}
                getInput={getInput}
                remove={remove}
                obj={certificates[index]}
                title={"Teach First"}
                id={3}
              />
            </Col>
            <Col lg={7} md={7} sm={12} xs={12}>
              <InputCheckForQualification
                headTitle={"teachingAndEducation"}
                otherHeadTitles={["doctoralDegree"]}
                getInput={getInput}
                remove={remove}
                obj={certificates[index]}
                title={"Bachelor of Education"}
                id={4}
              />
            </Col>
            <Col lg={5} md={5} sm={12} xs={12}>
              <InputCheckForQualification
                headTitle={"teachingAndEducation"}
                otherHeadTitles={["doctoralDegree"]}
                getInput={getInput}
                remove={remove}
                obj={certificates[index]}
                title={"SCITT"}
                id={5}
              />
            </Col>

            <Col lg={12} md={12} sm={12} xs={12}>
              <p className="title">Doctoral Degree</p>
            </Col>
            <Col lg={5} md={5} sm={12} xs={12}>
              <InputCheckForQualification
                getInput={getInput}
                remove={remove}
                headTitle={"doctoralDegree"}
                otherHeadTitles={["teachingAndEducation"]}
                obj={certificates[index]}
                title={"University Lecturer"}
                id={6}
              />
            </Col>
            <Col lg={7} md={7} sm={12} xs={12}>
              <InputCheckForQualification
                getInput={getInput}
                remove={remove}
                headTitle={"doctoralDegree"}
                otherHeadTitles={["teachingAndEducation"]}
                obj={certificates[index]}
                title={"University Professor"}
                id={7}
              />
            </Col>
          </Row>

          <div
            style={{ borderBottom: "1px solid #00000033", marginTop: "30px" }}
          />

          <div className="modal-footer">
            <div className="row flex-center" style={{ width: "100%" }}>
              <div className="col-6 text-left">
                <button className="cancel" onClick={onclose}>
                  Cancel
                </button>
              </div>
              <div className="col-6 text-right">
                <button className="btn-save" onClick={SaveAndCancel}>
                  Save
                </button>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  const {
    ApplicationFormReducer: { TutorInfoObj },
  } = state;

  return {
    TutorInfoObj,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddTutorInfo: (payload) =>
      dispatch(ApplicationFormAction.AddTutorInfo(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(QualificationModal);
